/* ============================================================
   WGH Product Options — wgh-product-options.js
   ============================================================ */

(function () {
  'use strict';

  /* ── Helpers ─────────────────────────────────────────────── */
  function fmt(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── State ───────────────────────────────────────────────── */
  var state = {};
  // optionId → { price (cents), name, active, variantId|null }  — priced text/switch/textarea
  var surchargeItems = {};
  // price (cents) → variantId  — populated by loadSurchargeVariants()
  var surchargeVariantCache = {};
  var surchargeLoadPromise = null;
  // optionId → { variant_id, price, selected }  — addon products
  var addonItems = {};
  // optionId → { variant_id, price (discounted, cents), quantity, selected }
  var upsellItems = {};
  var loadedFonts = {};
  var _swatchPopupEl = null;
  var hiddenContainer = null;
  var isSecondPass = false;
  var _initializing = false;
  var apiBase = '';
  var _globalMapboxToken = '';

  /* ── DOM refs ─────────────────────────────────────────────── */
  var mount   = null;
  var totalEl = null;
  var productId = null;
  var basePrice = 0;
  var _atcBtn = null;

  /* ── Required field validation ───────────────────────────── */
  function injectErrorStyles() {
    if (document.getElementById('wgh-opts-error-styles')) return;
    var s = document.createElement('style');
    s.id = 'wgh-opts-error-styles';
    s.textContent =
      '.wgh-opt__required{color:#c0392b;font-weight:700;margin-left:2px}' +
      '.wgh-opt__error-msg{color:#c0392b;font-size:.82em;margin-top:4px;display:none}' +
      '.wgh-opt--error .wgh-opt__error-msg{display:block}' +
      '.wgh-opt--error input[type="text"],.wgh-opt--error textarea{outline:2px solid #c0392b;outline-offset:1px}' +
      '.wgh-opt--error .wgh-opt-upload{outline:2px solid #c0392b;outline-offset:1px;border-radius:4px}' +
      '.wgh-opt--error .wgh-opt-addon{outline:2px solid #c0392b;outline-offset:2px;border-radius:8px}' +
      '.wgh-opt--error .wgh-opt-imgswatches{outline:2px solid #c0392b;outline-offset:2px;border-radius:8px}' +
      '.wgh-opt--hidden{display:none}' +
      '.wgh-personalizer-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:13px 20px;background:#2c1a0e;color:#fff;border:none;border-radius:6px;font-size:15px;font-weight:600;letter-spacing:.02em;cursor:pointer;transition:background .2s,transform .1s;margin-top:4px}' +
      '.wgh-personalizer-btn:hover{background:#4a2e1a}' +
      '.wgh-personalizer-btn:active{transform:scale(.98)}' +
      '.wgh-opt-upload__spinner{display:none;width:22px;height:22px;border:3px solid rgba(0,0,0,.15);border-top-color:#555;border-radius:50%;animation:wgh-spin .7s linear infinite;flex-shrink:0}' +
      '@keyframes wgh-spin{to{transform:rotate(360deg)}}' +
      '.wgh-opt-upload.is-uploading .wgh-opt-upload__spinner{display:block}' +
      '.wgh-opt-upload.is-uploading .wgh-opt-upload__icon,.wgh-opt-upload.is-uploading .wgh-opt-upload__text{opacity:.4;pointer-events:none}' +
      '.wgh-opt-upload__upload-error{color:#c0392b;font-size:.82em;margin-top:4px;display:none}' +
      '.wgh-opt-imgswatches{display:flex;flex-wrap:wrap;gap:8px}' +
      '.wgh-opt-imgswatch{position:relative;display:flex;flex-direction:column;align-items:center;cursor:pointer;border:none;background:none;padding:4px;width:calc(25% - 6px);overflow:visible}' +
      '.wgh-opt-imgswatch__ring{width:56px;height:56px;border-radius:50%;overflow:hidden;position:relative;box-shadow:0 0 0 2px transparent,0 0 0 4px transparent;transition:transform .15s ease,box-shadow .15s ease}' +
      '.wgh-opt-imgswatch:hover{z-index:10}' +
      '.wgh-opt-imgswatch:hover .wgh-opt-imgswatch__ring{transform:scale(1.12);transform-origin:top center}' +
      '.wgh-opt-imgswatch.is-selected .wgh-opt-imgswatch__ring{box-shadow:0 0 0 2px #fff,0 0 0 4px #333}' +
      '.wgh-opt-imgswatch__ring img{width:100%;height:100%;object-fit:cover;display:block}' +
      '.wgh-opt-imgswatch__placeholder{width:100%;height:100%;background:#e5e7eb;display:block}' +
      '.wgh-opt-imgswatch__check{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.4);color:#fff;border-radius:50%;opacity:0;transition:opacity .15s}' +
      '.wgh-opt-imgswatch.is-selected .wgh-opt-imgswatch__check{opacity:1}' +
      '.wgh-opt-imgswatch__check svg{width:18px;height:18px}' +
      '.wgh-opt-imgswatch__name{font-size:.78em;text-align:center;line-height:1.2;margin-top:15px}' +
      '.wgh-opt-imgswatch__price{font-size:.75em;color:#666;margin-top:3px}' +
      '.wgh-opt-tiles{display:flex;flex-wrap:wrap;gap:8px}' +
      '.wgh-opt-tile{display:flex;flex-direction:column;align-items:center;padding:7px 14px;border:1.5px solid #d5d0c8;border-radius:8px;background:none;cursor:pointer;min-width:56px;transition:border-color .15s,background .15s}' +
      '.wgh-opt-tile:hover{border-color:#999}' +
      '.wgh-opt-tile.is-selected{border-color:#333;background:#f5f2ec}' +
      '.wgh-opt-tile__label{font-size:.9em;font-weight:600;line-height:1.2}' +
      '.wgh-opt-tile__sublabel{font-size:.75em;color:#999;margin-top:2px;white-space:nowrap}' +
      '.wgh-opt-tile.is-selected .wgh-opt-tile__sublabel{color:#666}' +
      '.wgh-opt-tile__price{font-size:.75em;color:#666;margin-top:2px}' +
      '.wgh-opts-total{margin-top:16px;padding-top:12px;border-top:1px solid #e5e7eb}' +
      '.wgh-opt--info{padding:0}' +
      '.wgh-opt-info{font-size:.95em;line-height:1.65;color:#333}' +
      '.wgh-opt-info p{margin:0 0 .6em}.wgh-opt-info p:last-child{margin-bottom:0}' +
      '.wgh-opt-info img{max-width:100%;height:auto;border-radius:6px;vertical-align:middle}' +
      '.wgh-opt-info img[style*="display:block"]{display:block;margin:8px 0}' +
      '.wgh-opt-info a{color:#2c1a0e;text-decoration:underline}' +
      '.wgh-opts-total__label{font-size:.82em;color:#888;display:block}' +
      '.wgh-opts-total__value{font-size:1em;font-weight:600;color:#333;display:block;margin-top:2px}' +
      '.wgh-opt-fonts{display:flex;flex-wrap:wrap;gap:8px}' +
      '.wgh-opt-font{display:flex;flex-direction:column;align-items:center;padding:10px 14px;border:1.5px solid #d5d0c8;border-radius:8px;background:none;cursor:pointer;min-width:80px;transition:border-color .15s,background .15s}' +
      '.wgh-opt-font:hover{border-color:#999}' +
      '.wgh-opt-font.is-selected{border-color:#333;background:#f5f2ec}' +
      '.wgh-opt-font__preview{font-size:1.4em;line-height:1.3;display:block}' +
      '.wgh-opt-font__name{font-size:.72em;color:#888;margin-top:5px;display:block}' +
      '.wgh-opt-font.is-selected .wgh-opt-font__name{color:#555}' +
      '.wgh-opt-imgswatch__popup{display:none}' +
      '.wgh-opt-perchar-info{font-size:.8em;color:#888;margin:2px 0 6px}' +
      '.wgh-opt-perunit-info{font-size:.8em;color:#888;margin:2px 0 6px}' +
      '.wgh-opt-number-wrap{display:flex;align-items:center;gap:4px}' +
      '.wgh-opt-number__btn{width:32px;height:32px;border:1.5px solid #d5d0c8;border-radius:6px;background:#fff;cursor:pointer;font-size:1.15em;line-height:1;display:flex;align-items:center;justify-content:center;color:#333;transition:border-color .15s,background .15s}' +
      '.wgh-opt-number__btn:hover:not(:disabled){border-color:#999;background:#f5f2ec}' +
      '.wgh-opt-number__btn:disabled{color:#bbb;cursor:not-allowed}' +
      '.wgh-opt-number__input{width:70px;text-align:center;border:1.5px solid #d5d0c8;border-radius:6px;padding:5px 8px;font-size:.95em}' +
      '.wgh-opt-number__input::-webkit-inner-spin-button,.wgh-opt-number__input::-webkit-outer-spin-button{-webkit-appearance:none}' +
      '.wgh-opt-number__input{-moz-appearance:textfield}' +
      '.wgh-opt-api-error{background:#fef2f2;border:1px solid #fca5a5;color:#c0392b;padding:10px 14px;border-radius:6px;font-size:.9em;margin-bottom:12px;display:none}';
    document.head.appendChild(s);
  }

  function showWghError(msg) {
    var errEl = mount && mount.querySelector('.wgh-opt-api-error');
    if (!errEl) {
      errEl = document.createElement('div');
      errEl.className = 'wgh-opt-api-error';
      if (mount) mount.insertBefore(errEl, mount.firstChild);
    }
    errEl.textContent = msg;
    errEl.style.display = 'block';
    errEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function validateRequired() {
    var valid = true;
    if (!mount) return valid;
    mount.querySelectorAll('.wgh-opt[data-required="true"]').forEach(function (el) {
      if (el.classList.contains('wgh-opt--hidden')) return;
      var type = el.dataset.type;
      var empty = false;
      if (type === 'text') {
        var inp = el.querySelector('input[type="text"]');
        empty = !inp || !inp.value.trim();
      } else if (type === 'textarea') {
        var ta = el.querySelector('textarea');
        empty = !ta || !ta.value.trim();
      } else if (type === 'upload') {
        var fileInp = el.querySelector('input[type="file"]');
        empty = !fileInp || !state[fileInp.dataset.prop];
      } else if (type === 'addon') {
        var card = el.querySelector('.wgh-opt-addon');
        var addonId = card && card.dataset.addonId;
        empty = !addonItems[addonId] || !addonItems[addonId].selected;
      } else if (type === 'image_swatch') {
        empty = !el.querySelector('.wgh-opt-imgswatch.is-selected');
      } else if (type === 'font') {
        empty = !el.querySelector('.wgh-opt-font.is-selected');
      } else if (type === 'number') {
        var numInp = el.querySelector('.wgh-opt-number__input');
        empty = !numInp || !(parseFloat(numInp.value) > 0);
      } else if (type === 'switch') {
        var sw = el.querySelector('.wgh-opt-switch');
        empty = !sw || !sw.classList.contains('is-on');
      }
      if (empty) {
        el.classList.add('wgh-opt--error');
        valid = false;
      } else {
        el.classList.remove('wgh-opt--error');
      }
    });
    return valid;
  }

  /* ── Hidden inputs (line item properties) ───────────────── */
  function setHidden(name, value) {
    if (!hiddenContainer) return;
    var existing = hiddenContainer.querySelector('[data-prop="' + name + '"]');
    if (value === '' || value == null) {
      if (existing) existing.remove();
      return;
    }
    if (!existing) {
      existing = document.createElement('input');
      existing.type = 'hidden';
      existing.dataset.prop = name;
      hiddenContainer.appendChild(existing);
    }
    existing.name  = 'properties[' + name + ']';
    existing.value = value;
  }

  /* ── Price total ─────────────────────────────────────────── */
  function recalcTotal() {
    if (!totalEl) return;
    var extra = 0;
    Object.keys(surchargeItems).forEach(function (id) {
      var s = surchargeItems[id];
      if (s && s.active) extra += s.price;
    });
    Object.keys(addonItems).forEach(function (id) {
      var item = addonItems[id];
      if (item && item.selected) extra += item.price;
    });
    Object.keys(upsellItems).forEach(function (id) {
      var item = upsellItems[id];
      if (item && item.selected) extra += item.price * (item.quantity || 1);
    });
    if (extra > 0) {
      totalEl.querySelector('.wgh-opts-total__value').textContent = '+ ' + fmt(extra);
      var grandEl = totalEl.querySelector('.wgh-opts-grand__value');
      if (grandEl) grandEl.textContent = fmt(basePrice + extra);
      totalEl.removeAttribute('hidden');
    } else {
      totalEl.setAttribute('hidden', '');
    }
  }

  function stateChanged() {
    recalcTotal();
    evalConditions();
  }

  function evalSingleCond(c) {
    var current = state[c.prop] !== undefined ? state[c.prop] : '';
    return Array.isArray(c.values) ? c.values.indexOf(current) !== -1 : current === c.value;
  }

  function evalShowIf(data) {
    // Nieuw formaat: { operator, conditions }
    if (Array.isArray(data.conditions)) {
      if (!data.conditions.length) return true;
      return data.operator === 'or'
        ? data.conditions.some(evalSingleCond)
        : data.conditions.every(evalSingleCond);
    }
    // Oud formaat: { prop, value } — backward compat
    return evalSingleCond(data);
  }

  function evalConditions() {
    if (_initializing || !mount) return;
    var changed = false;
    mount.querySelectorAll('.wgh-opt[data-show-if]').forEach(function (el) {
      var data;
      try { data = JSON.parse(el.dataset.showIf); } catch (e) { return; }
      var match    = evalShowIf(data);
      var isHidden = el.classList.contains('wgh-opt--hidden');
      if (!match && !isHidden) {
        el.classList.add('wgh-opt--hidden');
        clearOptForEl(el);
        changed = true;
      } else if (match && isHidden) {
        el.classList.remove('wgh-opt--hidden');
        changed = true;
      }
    });
    if (changed) recalcTotal();
  }

  function clearOptForEl(el) {
    var optId = el.dataset.optId;
    if (surchargeItems[optId]) surchargeItems[optId].active = false;
    if (addonItems[optId]) addonItems[optId].selected = false;
    if (upsellItems[optId]) upsellItems[optId].selected = false;
    el.querySelectorAll('[data-prop]').forEach(function (propEl) {
      var prop = propEl.dataset.prop;
      if (prop) { delete state[prop]; setHidden(prop, ''); }
    });
  }

  function watchVariantSelectors(form) {
    // Dawn theme gebruikt soms "options[Maat]" als input-naam i.p.v. gewoon "Maat".
    // We normaliseren beide naar de schone optienaam zodat show_if condities altijd matchen.
    function optionName(name) {
      var m = name.match(/^options\[(.+)\]$/);
      return m ? m[1] : name;
    }
    function setVariantState(name, value) {
      state[name] = value;
      state[optionName(name)] = value;
    }
    function captureCurrentValues() {
      document.querySelectorAll('select, input[type="radio"]:checked').forEach(function (el) {
        if (!el.name || el.name === 'id' || el.name.startsWith('properties[')) return;
        if (el.name === 'Title' && el.value === 'Default Title') return;
        setVariantState(el.name, el.value);
      });
    }
    captureCurrentValues();
    // Luister op document-niveau zodat variant-selectors buiten het form ook worden gevangen
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (!el.name || el.name === 'id' || el.name.startsWith('properties[')) return;
      if (el.name === 'Title' && el.value === 'Default Title') return;
      if (el.tagName === 'SELECT' || (el.tagName === 'INPUT' && el.type === 'radio' && el.checked)) {
        setVariantState(el.name, el.value);
        evalConditions();
      }
    });
  }

  /* ── Render functions per field_type ─────────────────────── */

  function renderUpload(opt) {
    var name     = opt.config.name || opt.label;
    var label    = opt.config.upload_label || 'Upload bestand';
    var id       = 'wgh-opt-upload-' + opt.id;
    var required = opt.config.required ? ' data-required="true"' : '';
    var reqMark  = opt.config.required ? '<span class="wgh-opt__required" aria-label="verplicht">*</span>' : '';
    var errMsg   = opt.config.required ? '<div class="wgh-opt__error-msg">Dit veld is verplicht.</div>' : '';
    var showIf   = opt.config.show_if ? ' data-show-if="' + esc(JSON.stringify(opt.config.show_if)) + '"' : '';
    var initHide = opt.config.show_if ? ' wgh-opt--hidden' : '';

    return (
      '<div class="wgh-opt' + initHide + '" data-opt-id="' + opt.id + '" data-type="upload"' + required + showIf + '>' +
        '<div class="wgh-opt__label">' + esc(opt.label) + reqMark + '</div>' +
        '<label class="wgh-opt-upload" for="' + id + '">' +
          '<input type="file" id="' + id + '" accept="image/jpeg,image/png,image/gif,image/webp,image/tiff,image/bmp,image/heic,image/heif" data-prop="' + esc(name) + '">' +
          '<svg class="wgh-opt-upload__icon" viewBox="0 0 24 24" aria-hidden="true">' +
            '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>' +
            '<polyline points="17 8 12 3 7 8"/>' +
            '<line x1="12" y1="3" x2="12" y2="15"/>' +
          '</svg>' +
          '<div class="wgh-opt-upload__text"><strong>' + esc(label) + '</strong><br>of sleep hier naartoe</div>' +
          '<div class="wgh-opt-upload__spinner" aria-hidden="true"></div>' +
        '</label>' +
        '<div class="wgh-opt-upload__preview" data-preview>' +
          '<img class="wgh-opt-upload__preview-thumb" src="" alt="" data-thumb>' +
          '<span class="wgh-opt-upload__preview-name" data-fname></span>' +
          '<button type="button" class="wgh-opt-upload__remove" data-remove aria-label="Verwijder bestand">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="wgh-opt-upload__upload-error" data-upload-error></div>' +
        errMsg +
      '</div>'
    );
  }

  function renderText(opt) {
    var name         = opt.config.name || opt.label;
    var maxCh        = opt.config.max_chars || 0;
    var counter      = maxCh ? '<span class="wgh-opt-text-counter" data-counter>0/' + maxCh + '</span>' : '';
    var price        = opt.config.addon_price ? opt.config.addon_price * 100 : 0;
    var pricePerChar = opt.config.price_per_char ? Math.round(opt.config.price_per_char * 100) : 0;
    var badge        = price        ? '<span class="wgh-opt__label-badge">+ ' + fmt(price) + '</span>'
                     : pricePerChar ? '<span class="wgh-opt__label-badge" data-perchar-badge hidden></span>'
                     : '';
    var perCharInfo  = pricePerChar ? '<div class="wgh-opt-perchar-info">Prijs per teken: ' + fmt(pricePerChar) + ' (1e teken zit in de productprijs)</div>' : '';
    var perCharAttr  = pricePerChar ? ' data-price-per-char="' + pricePerChar + '"' : '';
    var svid         = opt.config.surcharge_variant_id ? ' data-surcharge-variant-id="' + esc(opt.config.surcharge_variant_id) + '"' : '';
    var required     = opt.config.required ? ' data-required="true"' : '';
    var reqMark      = opt.config.required ? '<span class="wgh-opt__required" aria-label="verplicht">*</span>' : '';
    var errMsg       = opt.config.required ? '<div class="wgh-opt__error-msg">Dit veld is verplicht.</div>' : '';
    var showIf       = opt.config.show_if ? ' data-show-if="' + esc(JSON.stringify(opt.config.show_if)) + '"' : '';
    var initHide     = opt.config.show_if ? ' wgh-opt--hidden' : '';
    return (
      '<div class="wgh-opt' + initHide + '" data-opt-id="' + opt.id + '" data-type="text" data-price="' + price + '"' + svid + perCharAttr + required + showIf + '>' +
        '<div class="wgh-opt__label">' + esc(opt.label) + reqMark + badge + '</div>' +
        perCharInfo +
        '<div class="wgh-opt-text-wrap">' +
          '<input type="text" placeholder="' + esc(opt.config.placeholder || opt.label) + '" data-prop="' + esc(name) + '"' +
            (maxCh ? ' maxlength="' + maxCh + '"' : '') + '>' +
          counter +
        '</div>' +
        errMsg +
      '</div>'
    );
  }

  function renderTextarea(opt) {
    var name     = opt.config.name || opt.label;
    var maxCh    = opt.config.max_chars || 0;
    var counter  = maxCh
      ? '<div class="wgh-opt-textarea-counter" data-counter>0/' + maxCh + '</div>'
      : '';
    var price    = opt.config.addon_price ? opt.config.addon_price * 100 : 0;
    var badge    = price ? '<span class="wgh-opt__label-badge">+ ' + fmt(price) + '</span>' : '';
    var svid     = opt.config.surcharge_variant_id ? ' data-surcharge-variant-id="' + esc(opt.config.surcharge_variant_id) + '"' : '';
    var required = opt.config.required ? ' data-required="true"' : '';
    var reqMark  = opt.config.required ? '<span class="wgh-opt__required" aria-label="verplicht">*</span>' : '';
    var errMsg   = opt.config.required ? '<div class="wgh-opt__error-msg">Dit veld is verplicht.</div>' : '';
    var showIf   = opt.config.show_if ? ' data-show-if="' + esc(JSON.stringify(opt.config.show_if)) + '"' : '';
    var initHide = opt.config.show_if ? ' wgh-opt--hidden' : '';
    return (
      '<div class="wgh-opt' + initHide + '" data-opt-id="' + opt.id + '" data-type="textarea" data-price="' + price + '"' + svid + required + showIf + '>' +
        '<div class="wgh-opt__label">' + esc(opt.label) + reqMark + badge + '</div>' +
        '<div class="wgh-opt-textarea-wrap">' +
          '<textarea placeholder="' + esc(opt.config.placeholder || opt.label) + '" data-prop="' + esc(name) + '"' +
            (maxCh ? ' maxlength="' + maxCh + '"' : '') + '></textarea>' +
          counter +
        '</div>' +
        errMsg +
      '</div>'
    );
  }

  function renderSwitch(opt) {
    var name         = opt.config.name || opt.label;
    var checkedVal   = opt.config.checked_value   || 'Ja';
    var uncheckedVal = opt.config.unchecked_value  || 'Nee';
    var isOn         = !!opt.config.default;
    var price        = opt.config.addon_price ? opt.config.addon_price * 100 : 0;
    var priceTag     = price ? '<span class="wgh-opt-switch__price">+ ' + fmt(price) + '</span>' : '';
    var svid         = opt.config.surcharge_variant_id ? ' data-surcharge-variant-id="' + esc(opt.config.surcharge_variant_id) + '"' : '';
    var showIf       = opt.config.show_if ? ' data-show-if="' + esc(JSON.stringify(opt.config.show_if)) + '"' : '';
    var initHide     = opt.config.show_if ? ' wgh-opt--hidden' : '';
    var required     = opt.config.required ? ' data-required="true"' : '';
    var reqMark      = opt.config.required ? '<span class="wgh-opt__required" aria-label="verplicht">*</span>' : '';
    var errMsg       = opt.config.required ? '<div class="wgh-opt__error-msg">Bevestig dit veld om verder te gaan.</div>' : '';
    return (
      '<div class="wgh-opt' + initHide + '" data-opt-id="' + opt.id + '" data-type="switch" data-price="' + price + '"' + svid + required + showIf + '>' +
        '<div class="wgh-opt-switch' + (isOn ? ' is-on' : '') + '" role="switch" aria-checked="' + isOn + '" tabindex="0"' +
          ' data-prop="' + esc(name) + '"' +
          ' data-checked-val="' + esc(checkedVal) + '"' +
          ' data-unchecked-val="' + esc(uncheckedVal) + '">' +
          '<div class="wgh-opt-switch__check">' +
            '<svg viewBox="0 0 12 12" aria-hidden="true"><polyline points="2,6 5,9 10,3"/></svg>' +
          '</div>' +
          '<div class="wgh-opt-switch__body">' +
            '<span class="wgh-opt-switch__name">' + esc(opt.label) + reqMark + '</span>' +
            '<span class="wgh-opt-switch__text">' + esc(opt.config.label || '') + '</span>' +
          '</div>' +
          priceTag +
        '</div>' +
        errMsg +
      '</div>'
    );
  }

  function renderSelect(opt) {
    var name    = opt.config.name || opt.label;
    var values  = opt.config.values || [];
    var style   = opt.config.style || 'dropdown';
    var price   = opt.config.addon_price ? opt.config.addon_price * 100 : 0;
    var badge   = price ? '<span class="wgh-opt__label-badge">+ ' + fmt(price) + '</span>' : '';
    var showIf  = opt.config.show_if ? ' data-show-if="' + esc(JSON.stringify(opt.config.show_if)) + '"' : '';
    var inner   = '';

    if (style === 'colors') {
      inner = '<div class="wgh-opt-colors" data-prop="' + esc(name) + '">';
      values.forEach(function (v, idx) {
        var label  = typeof v === 'object' ? (v.label || v.value) : v;
        var value  = typeof v === 'object' ? (v.value || v.label || v) : v;
        var color  = typeof v === 'object' ? (v.color || '#ccc') : '#ccc';
        var sel    = idx === 0 ? ' is-selected' : '';
        inner += (
          '<button type="button" class="wgh-opt-color' + sel + '" data-value="' + esc(value) + '">' +
            '<span class="wgh-opt-color__dot" style="background:' + esc(color) + '"></span>' +
            '<span class="wgh-opt-color__name">' + esc(label) + '</span>' +
          '</button>'
        );
      });
      inner += '</div>';
    } else if (style === 'buttons') {
      inner = '<div class="wgh-opt-btns" data-prop="' + esc(name) + '">';
      values.forEach(function (v, idx) {
        var label = typeof v === 'object' ? (v.label || v.value) : v;
        var value = typeof v === 'object' ? (v.value || v.label || v) : v;
        var sel   = idx === 0 ? ' is-selected' : '';
        inner += (
          '<button type="button" class="wgh-opt-btn' + sel + '" data-value="' + esc(value) + '">' +
            esc(label) +
          '</button>'
        );
      });
      inner += '</div>';
    } else if (style === 'tiles') {
      inner = '<div class="wgh-opt-tiles" data-prop="' + esc(name) + '">';
      values.forEach(function (v, idx) {
        var label    = typeof v === 'object' ? (v.label || v.value) : v;
        var value    = typeof v === 'object' ? (v.value || v.label || v) : v;
        var sublabel = typeof v === 'object' ? (v.sublabel || '') : '';
        var vPrice   = typeof v === 'object' && v.addon_price ? v.addon_price * 100 : 0;
        var vSvid    = typeof v === 'object' && v.surcharge_variant_id ? v.surcharge_variant_id : '';
        var sel      = idx === 0 ? ' is-selected' : '';
        inner += (
          '<button type="button" class="wgh-opt-tile' + sel + '"' +
            ' data-value="' + esc(value) + '"' +
            ' data-price="' + vPrice + '"' +
            (vSvid ? ' data-surcharge-variant-id="' + esc(vSvid) + '"' : '') + '>' +
            '<span class="wgh-opt-tile__label">' + esc(label) + '</span>' +
            (sublabel ? '<span class="wgh-opt-tile__sublabel">' + esc(sublabel) + '</span>' : '') +
            (vPrice ? '<span class="wgh-opt-tile__price">+ ' + fmt(vPrice) + '</span>' : '') +
          '</button>'
        );
      });
      inner += '</div>';
    } else {
      var firstVal    = values[0];
      var firstVPrice = typeof firstVal === 'object' && firstVal && firstVal.addon_price ? firstVal.addon_price * 100 : 0;
      var initBadgePrice = firstVPrice > 0 ? firstVPrice : price;
      badge = initBadgePrice
        ? '<span class="wgh-opt__label-badge">+ ' + fmt(initBadgePrice) + '</span>'
        : '<span class="wgh-opt__label-badge" style="display:none"></span>';

      inner = '<div class="wgh-opt-select-wrap"><select data-prop="' + esc(name) + '">';
      values.forEach(function (v, idx) {
        var label  = typeof v === 'object' ? (v.label || v.value) : v;
        var value  = typeof v === 'object' ? (v.value || v.label || v) : v;
        var vPrice = typeof v === 'object' && v.addon_price ? v.addon_price * 100 : 0;
        var vSvid  = typeof v === 'object' && v.surcharge_variant_id ? v.surcharge_variant_id : '';
        var optLabel = vPrice > 0 ? label + ' (+ ' + fmt(vPrice) + ')' : label;
        inner += '<option value="' + esc(value) + '"' + (idx === 0 ? ' selected' : '') +
          ' data-price="' + vPrice + '"' + (vSvid ? ' data-svid="' + esc(vSvid) + '"' : '') +
          '>' + esc(optLabel) + '</option>';
      });
      inner += '</select></div>';
    }

    var initHide = opt.config.show_if ? ' wgh-opt--hidden' : '';
    var globalSvid = opt.config.surcharge_variant_id ? ' data-surcharge-variant-id="' + esc(opt.config.surcharge_variant_id) + '"' : '';
    return (
      '<div class="wgh-opt' + initHide + '" data-opt-id="' + opt.id + '" data-type="select" data-style="' + esc(style) + '" data-price="' + price + '"' + globalSvid + showIf + '>' +
        '<div class="wgh-opt__label">' + esc(opt.label) + badge + '</div>' +
        inner +
      '</div>'
    );
  }

  function renderAddon(opt) {
    var conf     = opt.config;
    var name     = conf.name || opt.label;
    var price    = conf.price ? conf.price * 100 : 0;
    var imgHtml  = conf.image
      ? '<img class="wgh-opt-addon__img" src="' + esc(conf.image) + '" alt="" loading="lazy">'
      : '<div class="wgh-opt-addon__img"></div>';
    var required = opt.config.required ? ' data-required="true"' : '';
    var reqMark  = opt.config.required ? '<span class="wgh-opt__required" aria-label="verplicht">*</span>' : '';
    var errMsg   = opt.config.required ? '<div class="wgh-opt__error-msg">Dit veld is verplicht.</div>' : '';
    var showIf   = opt.config.show_if ? ' data-show-if="' + esc(JSON.stringify(opt.config.show_if)) + '"' : '';
    var initHide = opt.config.show_if ? ' wgh-opt--hidden' : '';

    return (
      '<div class="wgh-opt' + initHide + '" data-opt-id="' + opt.id + '" data-type="addon"' + required + showIf + '>' +
        '<div class="wgh-opt__label">' + esc(opt.label) + reqMark + '</div>' +
        '<div class="wgh-opt-addon" role="checkbox" aria-checked="false" tabindex="0"' +
          ' data-addon-id="' + opt.id + '"' +
          ' data-variant-id="' + (conf.variant_id || '') + '"' +
          ' data-price="' + price + '">' +
          '<div class="wgh-opt-addon__checkbox">' +
            '<svg viewBox="0 0 12 12" aria-hidden="true"><polyline points="2,6 5,9 10,3"/></svg>' +
          '</div>' +
          imgHtml +
          '<div class="wgh-opt-addon__body">' +
            '<div class="wgh-opt-addon__name">' + esc(name) + '</div>' +
            (conf.description ? '<div class="wgh-opt-addon__desc">' + esc(conf.description) + '</div>' : '') +
          '</div>' +
          (price ? '<div class="wgh-opt-addon__price">+ ' + fmt(price) + '</div>' : '') +
        '</div>' +
        errMsg +
      '</div>'
    );
  }

  function renderUpsell(opt) {
    var conf       = opt.config;
    var title      = conf.title || opt.label;
    var imgSrc     = conf.image || '';
    var origPrice  = conf.original_price ? conf.original_price * 100 : 0;
    var discPrice  = conf.discount_amount
      ? origPrice - conf.discount_amount * 100
      : (conf.discount_pct ? Math.round(origPrice * (1 - conf.discount_pct / 100)) : origPrice);
    var showIf   = opt.config.show_if ? ' data-show-if="' + esc(JSON.stringify(opt.config.show_if)) + '"' : '';
    var initHide = opt.config.show_if ? ' wgh-opt--hidden' : '';

    // When any display field absent, fetch from Shopify API
    var needsFetch = (!conf.original_price || !conf.image || !conf.title || !conf.variant_name) && conf.variant_id;
    var fetchAttrs = needsFetch
      ? ' data-fetch-variant="1"' +
        (conf.product_handle  ? ' data-product-handle="'  + esc(conf.product_handle)  + '"' : '') +
        (conf.discount_pct    ? ' data-discount-pct="'    + conf.discount_pct          + '"' : '') +
        (conf.discount_amount ? ' data-discount-amount="' + conf.discount_amount        + '"' : '') +
        (!conf.image         ? ' data-fetch-image="1"'        : '') +
        (!conf.title         ? ' data-fetch-title="1"'        : '') +
        (!conf.variant_name  ? ' data-fetch-variant-name="1"' : '')
      : '';

    var variantName = conf.variant_name || '';
    var viewLink = conf.product_handle
      ? '<a class="wgh-opt-upsell__view-link" href="/products/' + esc(conf.product_handle) + '" target="_blank" rel="noopener" data-upsell-view>Product bekijken →</a>'
      : '';

    var origPriceHtml = (origPrice && origPrice !== discPrice)
      ? '<span class="wgh-opt-upsell__orig-price">' + fmt(origPrice) + '</span>'
      : '';
    var discountBadge = '';
    if (origPrice && origPrice !== discPrice) {
      if (conf.discount_pct) {
        discountBadge = '<span class="wgh-opt-upsell__badge">-' + Math.round(conf.discount_pct) + '%</span>';
      } else if (conf.discount_amount) {
        discountBadge = '<span class="wgh-opt-upsell__badge">-' + fmt(conf.discount_amount * 100) + '</span>';
      }
    }
    var pricingHtml = (needsFetch && !conf.original_price)
      ? '<span class="wgh-opt-upsell__price wgh-opt-upsell__price--loading">…</span>'
      : origPriceHtml + '<span class="wgh-opt-upsell__price">' + fmt(discPrice) + '</span>' + discountBadge;

    return (
      '<div class="wgh-opt' + initHide + '" data-opt-id="' + opt.id + '" data-type="upsell"' + showIf + '>' +
        '<div class="wgh-opt__label">' + esc(opt.label) + '</div>' +
        '<div class="wgh-opt-upsell" role="checkbox" aria-checked="false" tabindex="0"' + fetchAttrs +
          ' data-upsell-id="' + opt.id + '"' +
          ' data-variant-id="' + esc(conf.variant_id || '') + '"' +
          ' data-price="' + discPrice + '"' +
          ' data-orig-price="' + origPrice + '">' +
          (imgSrc ? '<img class="wgh-opt-upsell__img" src="' + esc(imgSrc) + '" alt="' + esc(title) + '" loading="lazy">' : '') +
          '<div class="wgh-opt-upsell__body">' +
            '<div class="wgh-opt-upsell__title">' + esc(title) + '</div>' +
            '<span class="wgh-opt-upsell__variant">' + esc(variantName) + '</span>' +
            (conf.description ? '<div class="wgh-opt-upsell__desc">' + esc(conf.description) + '</div>' : '') +
            '<div class="wgh-opt-upsell__pricing">' + pricingHtml + '</div>' +
            viewLink +
          '</div>' +
          '<div class="wgh-opt-upsell__controls">' +
            '<div class="wgh-opt-upsell__qty">' +
              '<button type="button" class="wgh-opt-upsell__qty-btn" data-upsell-minus aria-label="Minder" disabled>−</button>' +
              '<span class="wgh-opt-upsell__qty-val">1</span>' +
              '<button type="button" class="wgh-opt-upsell__qty-btn" data-upsell-plus aria-label="Meer" disabled>+</button>' +
            '</div>' +
            '<div class="wgh-opt-upsell__check-ui" aria-hidden="true">' +
              '<svg viewBox="0 0 12 12" aria-hidden="true"><polyline points="2,6 5,9 10,3"/></svg>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function renderImageSwatch(opt) {
    var name     = opt.config.name || opt.label;
    var values   = opt.config.values || [];
    var required = opt.config.required ? ' data-required="true"' : '';
    var reqMark  = opt.config.required ? '<span class="wgh-opt__required" aria-label="verplicht">*</span>' : '';
    var errMsg   = opt.config.required ? '<div class="wgh-opt__error-msg">Maak een keuze.</div>' : '';
    var showIf   = opt.config.show_if ? ' data-show-if="' + esc(JSON.stringify(opt.config.show_if)) + '"' : '';
    var initHide = opt.config.show_if ? ' wgh-opt--hidden' : '';

    var inner = '<div class="wgh-opt-imgswatches" data-prop="' + esc(name) + '">';
    values.forEach(function (v) {
      var label  = typeof v === 'object' ? (v.label || v.value) : v;
      var value  = typeof v === 'object' ? (v.value || v.label || v) : v;
      var image  = typeof v === 'object' ? (v.image || '') : '';
      var price  = typeof v === 'object' && v.addon_price ? v.addon_price * 100 : 0;
      var svid   = typeof v === 'object' && v.surcharge_variant_id ? v.surcharge_variant_id : '';
      var sel    = '';
      var priceHtml = price ? '<span class="wgh-opt-imgswatch__price">+ ' + fmt(price) + '</span>' : '';
      inner += (
        '<button type="button" class="wgh-opt-imgswatch' + sel + '"' +
          ' data-value="' + esc(value) + '"' +
          ' data-price="' + price + '"' +
          (svid ? ' data-surcharge-variant-id="' + esc(svid) + '"' : '') + '>' +
          '<span class="wgh-opt-imgswatch__ring">' +
            (image
              ? '<img src="' + esc(image) + '" alt="' + esc(label) + '" loading="lazy">'
              : '<span class="wgh-opt-imgswatch__placeholder"></span>') +
            '<span class="wgh-opt-imgswatch__check" aria-hidden="true">' +
              '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="2,6 5,9 10,3"/></svg>' +
            '</span>' +
          '</span>' +
          '<span class="wgh-opt-imgswatch__name">' + esc(label) + '</span>' +
          priceHtml +
          (image ? '<span class="wgh-opt-imgswatch__popup"><img src="' + esc(image) + '" alt="' + esc(label) + '"></span>' : '') +
        '</button>'
      );
    });
    inner += '</div>';

    var globalSvid = opt.config.surcharge_variant_id ? ' data-surcharge-variant-id="' + esc(opt.config.surcharge_variant_id) + '"' : '';
    return (
      '<div class="wgh-opt' + initHide + '" data-opt-id="' + opt.id + '" data-type="image_swatch"' + required + globalSvid + showIf + '>' +
        '<div class="wgh-opt__label">' + esc(opt.label) + reqMark + '</div>' +
        inner +
        errMsg +
      '</div>'
    );
  }

  function loadFont(family, url) {
    if (loadedFonts[family] || !family || !url) return;
    loadedFonts[family] = true;
    var s = document.createElement('style');
    s.textContent = '@font-face{font-family:"' + family.replace(/"/g, '') + '";src:url("' + url.replace(/"/g, '') + '")}';
    document.head.appendChild(s);
  }

  function renderFont(opt) {
    var name        = opt.config.name || opt.label;
    var values      = opt.config.values || [];
    var previewText = opt.config.preview_text || 'Jouw tekst';
    var required    = opt.config.required ? ' data-required="true"' : '';
    var reqMark     = opt.config.required ? '<span class="wgh-opt__required" aria-label="verplicht">*</span>' : '';
    var errMsg      = opt.config.required ? '<div class="wgh-opt__error-msg">Maak een keuze.</div>' : '';
    var showIf      = opt.config.show_if ? ' data-show-if="' + esc(JSON.stringify(opt.config.show_if)) + '"' : '';
    var initHide    = opt.config.show_if ? ' wgh-opt--hidden' : '';

    var inner = '<div class="wgh-opt-fonts" data-prop="' + esc(name) + '">';
    values.forEach(function (v, idx) {
      var label      = typeof v === 'object' ? (v.label || v.value) : v;
      var value      = typeof v === 'object' ? (v.value || v.label || v) : v;
      var fontFamily = typeof v === 'object' ? (v.font_family || '') : '';
      var fontUrl    = typeof v === 'object' ? (v.font_url    || '') : '';
      var sel        = idx === 0 ? ' is-selected' : '';
      inner += (
        '<button type="button" class="wgh-opt-font' + sel + '"' +
          ' data-value="' + esc(value) + '"' +
          ' data-font-family="' + esc(fontFamily) + '"' +
          (fontUrl ? ' data-font-url="' + esc(fontUrl) + '"' : '') + '>' +
          '<span class="wgh-opt-font__preview"' + (fontFamily ? ' style="font-family:\'' + fontFamily.replace(/'/g, '') + '\'"' : '') + '>' + esc(previewText) + '</span>' +
          '<span class="wgh-opt-font__name">' + esc(label) + '</span>' +
        '</button>'
      );
    });
    inner += '</div>';

    return (
      '<div class="wgh-opt' + initHide + '" data-opt-id="' + opt.id + '" data-type="font"' + required + showIf + '>' +
        '<div class="wgh-opt__label">' + esc(opt.label) + reqMark + '</div>' +
        inner +
        errMsg +
      '</div>'
    );
  }

  function renderInfo(opt) {
    var html     = opt.config.html_content || '';
    var showIf   = opt.config.show_if ? ' data-show-if="' + esc(JSON.stringify(opt.config.show_if)) + '"' : '';
    var initHide = opt.config.show_if ? ' wgh-opt--hidden' : '';
    if (!html) return '';
    return (
      '<div class="wgh-opt wgh-opt--info' + initHide + '" data-opt-id="' + opt.id + '" data-type="info"' + showIf + '>' +
        '<div class="wgh-opt-info">' + html + '</div>' +
      '</div>'
    );
  }

  function renderNumber(opt) {
    var name         = opt.config.name || opt.label;
    var min          = opt.config.min != null ? opt.config.min : 1;
    var max          = opt.config.max || 0;
    var step         = opt.config.step || 1;
    var pricePerUnit = opt.config.price_per_unit ? Math.round(opt.config.price_per_unit * 100) : 0;
    var badge        = pricePerUnit ? '<span class="wgh-opt__label-badge" data-number-badge hidden></span>' : '';
    var perUnitInfo  = pricePerUnit ? '<div class="wgh-opt-perunit-info">Meerprijs per eenheid: ' + fmt(pricePerUnit) + '</div>' : '';
    var perUnitAttr  = pricePerUnit ? ' data-price-per-unit="' + pricePerUnit + '"' : '';
    var svid         = opt.config.surcharge_variant_id ? ' data-surcharge-variant-id="' + esc(opt.config.surcharge_variant_id) + '"' : '';
    var required     = opt.config.required ? ' data-required="true"' : '';
    var reqMark      = opt.config.required ? '<span class="wgh-opt__required" aria-label="verplicht">*</span>' : '';
    var errMsg       = opt.config.required ? '<div class="wgh-opt__error-msg">Dit veld is verplicht.</div>' : '';
    var showIf       = opt.config.show_if ? ' data-show-if="' + esc(JSON.stringify(opt.config.show_if)) + '"' : '';
    var initHide     = opt.config.show_if ? ' wgh-opt--hidden' : '';
    return (
      '<div class="wgh-opt' + initHide + '" data-opt-id="' + opt.id + '" data-type="number"' + perUnitAttr + svid + required + showIf + '>' +
        '<div class="wgh-opt__label">' + esc(opt.label) + reqMark + badge + '</div>' +
        perUnitInfo +
        '<div class="wgh-opt-number-wrap">' +
          '<button type="button" class="wgh-opt-number__btn" data-number-minus aria-label="Minder">−</button>' +
          '<input type="number"' +
            ' class="wgh-opt-number__input"' +
            ' data-prop="' + esc(name) + '"' +
            ' value="' + min + '"' +
            ' min="' + min + '"' +
            (max ? ' max="' + max + '"' : '') +
            ' step="' + step + '"' +
            (opt.config.placeholder ? ' placeholder="' + esc(opt.config.placeholder) + '"' : '') + '>' +
          '<button type="button" class="wgh-opt-number__btn" data-number-plus aria-label="Meer">+</button>' +
        '</div>' +
        errMsg +
      '</div>'
    );
  }

  function wireNumber(el) {
    var input        = el.querySelector('.wgh-opt-number__input');
    var minusBtn     = el.querySelector('[data-number-minus]');
    var plusBtn      = el.querySelector('[data-number-plus]');
    var badge        = el.querySelector('[data-number-badge]');
    if (!input) return;
    var prop         = input.dataset.prop;
    var pricePerUnit = parseInt(el.dataset.pricePerUnit) || 0;
    var svid         = el.dataset.surchargeVariantId || null;
    var optId        = el.dataset.optId;
    var minVal       = parseFloat(input.min) || 0;
    var maxVal       = parseFloat(input.max) || 0;
    var step         = parseFloat(input.step) || 1;

    function clamp(v) {
      v = Math.round(v / step) * step;
      v = Math.max(minVal, v);
      if (maxVal > 0) v = Math.min(maxVal, v);
      return v;
    }

    function update(val) {
      val = clamp(val);
      input.value = val;
      state[prop] = String(val);
      setHidden(prop, String(val));
      if (el.dataset.required && val > 0) el.classList.remove('wgh-opt--error');

      if (pricePerUnit) {
        var surcharge = val * pricePerUnit;
        surchargeItems[optId] = {
          price:        surcharge,
          pricePerUnit: pricePerUnit,
          quantity:     val,
          name:         prop,
          active:       surcharge > 0,
          variantId:    svid,
          numberValue:  val,
          isPerUnit:    true
        };
        if (badge) {
          if (surcharge > 0) {
            badge.textContent = '+ ' + fmt(surcharge);
            badge.removeAttribute('hidden');
          } else {
            badge.setAttribute('hidden', '');
          }
        }
        stateChanged();
      } else {
        stateChanged();
      }

      if (minusBtn) minusBtn.disabled = val <= minVal;
      if (plusBtn)  plusBtn.disabled  = maxVal > 0 && val >= maxVal;
    }

    update(clamp(parseFloat(input.value) || minVal));

    input.addEventListener('blur', function () { update(parseFloat(this.value) || minVal); });
    input.addEventListener('input', function () {
      var val = parseFloat(this.value) || 0;
      state[prop] = String(val);
      setHidden(prop, String(val));
    });

    if (minusBtn) minusBtn.addEventListener('click', function () { update((parseFloat(input.value) || 0) - step); });
    if (plusBtn)  plusBtn.addEventListener('click',  function () { update((parseFloat(input.value) || 0) + step); });
  }

  function renderConfigurator(opt) {
    var config  = opt.config || {};
    var btnLabel = opt.label || 'Personaliseren';
    return (
      '<div class="wgh-opt" data-opt-id="' + opt.id + '" data-type="configurator"' +
        ' data-configurator-config="' + esc(JSON.stringify(config)) + '">' +
        '<button type="button" class="wgh-personalizer-btn">' +
          '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M12 20h9"/>' +
            '<path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>' +
          '</svg>' +
          esc(btnLabel) +
        '</button>' +
      '</div>'
    );
  }

  function wireConfigurator(el) {
    var btn = el.querySelector('.wgh-personalizer-btn');

    var config = {};
    try { config = JSON.parse(el.dataset.configuratorConfig || '{}'); } catch (e) {}

    if (!btn) return;

    btn.addEventListener('click', function () {
      var p = window._personalizer;
      if (!p) {
        console.warn('[WGH] Personalizer niet geladen.');
        return;
      }

      // Haal de huidige variant ID op uit het product formulier
      var form = document.querySelector('form[action*="/cart/add"]');
      var variantInput = form && form.querySelector('input[name="id"]');
      var variantId = variantInput ? parseInt(variantInput.value, 10) : null;

      // Productnaam van de pagina
      var titleEl = document.querySelector('h1.product__title, h1[itemprop="name"], .product-title, h1');
      var productTitle = titleEl ? titleEl.textContent.trim() : '';

      // API sluit: "safezone" (kleine letters) → {x,y,width,height}
      var safeZone = config.safezone || config.safeZone || null;

      p.open({
        backgroundUrl:          config.background_url           || '',
        allowedRotations:       config.allowed_rotations        || [0],
        disabledTabsByRotation: config.disabled_tabs_by_rotation || {},
        disabledTabs:           config.disabled_tabs            || [],
        mapShape:               config.map_shape               || null,
        mapSize:                config.map_size                || null,
        mapPosition:            config.map_position            || null,
        safeZone:               safeZone,
        variantId:              variantId,
        productId:              productId,
        productTitle:           productTitle,
        apiUrl:                 apiBase + '/api/',
        priorityView:           config.priority_view            || 'designer',
        mapboxToken:            config.mapbox_token             || _globalMapboxToken || '',
        mapboxStyleUrl:         config.mapbox_style_url         || '',
      });
    });
  }

  /* ── Wire events after render ────────────────────────────── */
  function wireUpload(el) {
    var input     = el.querySelector('input[type="file"]');
    var preview   = el.querySelector('[data-preview]');
    var thumb     = el.querySelector('[data-thumb]');
    var fname     = el.querySelector('[data-fname]');
    var remove    = el.querySelector('[data-remove]');
    var zone      = el.querySelector('.wgh-opt-upload');
    var uploadErr = el.querySelector('[data-upload-error]');
    var prop      = input ? input.dataset.prop : '';

    if (!input) return;

    function setLoading(on) {
      if (zone) zone.classList.toggle('is-uploading', on);
      input.disabled = on;
    }

    function showUploadError(msg) {
      if (uploadErr) { uploadErr.textContent = msg; uploadErr.style.display = 'block'; }
    }

    function clearUploadError() {
      if (uploadErr) { uploadErr.textContent = ''; uploadErr.style.display = 'none'; }
    }

    function showPreview(file, uploadUrl) {
      if (fname) fname.textContent = file.name;
      if (thumb) { thumb.src = uploadUrl; thumb.style.display = ''; }
      if (preview) preview.classList.add('is-visible');
      setHidden(prop, uploadUrl);
      state[prop] = uploadUrl;
      el.classList.remove('wgh-opt--error');
    }

    function clearPreview() {
      input.value = '';
      if (preview) preview.classList.remove('is-visible');
      if (thumb) { thumb.src = ''; }
      clearUploadError();
      setHidden(prop, '');
      delete state[prop];
    }

    function handleFile(file) {
      clearUploadError();
      setLoading(true);
      var formData = new FormData();
      formData.append('file', file);
      fetch(apiBase + '/api/public/products/upload', { method: 'POST', body: formData })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.error || 'Upload mislukt. Probeer het opnieuw.');
            return data;
          });
        })
        .then(function (data) {
          if (!data.url) throw new Error('Geen URL in response');
          setLoading(false);
          var uploadUrl = data.url.startsWith('http') ? data.url : apiBase + data.url;
          showPreview(file, uploadUrl);
        })
        .catch(function (err) {
          setLoading(false);
          input.value = '';
          showUploadError(err.message);
          console.warn('[WGH options] upload error:', err);
        });
    }

    input.addEventListener('change', function () {
      if (this.files && this.files[0]) handleFile(this.files[0]);
    });

    if (zone) {
      zone.addEventListener('dragover', function (e) {
        e.preventDefault();
        this.classList.add('is-over');
      });
      zone.addEventListener('dragleave', function () {
        this.classList.remove('is-over');
      });
      zone.addEventListener('drop', function (e) {
        e.preventDefault();
        this.classList.remove('is-over');
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
          input.files = e.dataTransfer.files;
          handleFile(e.dataTransfer.files[0]);
        }
      });
    }

    if (remove) {
      remove.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearPreview();
      });
    }
  }

  function wireText(el) {
    var input        = el.querySelector('input[type="text"]');
    var counter      = el.querySelector('[data-counter]');
    var perCharBadge = el.querySelector('[data-perchar-badge]');
    if (!input) return;
    var prop         = input.dataset.prop;
    var maxCh        = input.maxLength > 0 ? input.maxLength : 0;
    var price        = parseInt(el.dataset.price) || 0;
    var pricePerChar = parseInt(el.dataset.pricePerChar) || 0;
    var svid         = el.dataset.surchargeVariantId || null;
    var optId        = el.dataset.optId;

    input.addEventListener('input', function () {
      var val = this.value;
      state[prop] = val;
      setHidden(prop, val);

      if (pricePerChar) {
        var qty      = Math.max(0, val.length - 1);
        var surcharge = qty * pricePerChar;
        surchargeItems[optId] = {
          price:        surcharge,
          pricePerChar: pricePerChar,
          quantity:     qty,
          name:         prop,
          active:       qty > 0,
          variantId:    svid,
          textValue:    val,
          isPerChar:    true
        };
        if (perCharBadge) {
          if (surcharge > 0) {
            perCharBadge.textContent = '+ ' + fmt(surcharge);
            perCharBadge.removeAttribute('hidden');
          } else {
            perCharBadge.setAttribute('hidden', '');
          }
        }
        stateChanged();
      } else if (price) {
        if (!surchargeItems[optId]) surchargeItems[optId] = { price: price, name: prop, active: false, variantId: svid };
        surchargeItems[optId].active = val.length > 0;
        stateChanged();
      }
      if (el.dataset.required && val.trim()) el.classList.remove('wgh-opt--error');
      if (counter && maxCh) {
        var len = val.length;
        counter.textContent = len + '/' + maxCh;
        counter.className = 'wgh-opt-text-counter' +
          (len >= maxCh ? ' is-over' : len >= maxCh * 0.85 ? ' is-near' : '');
      }
    });
  }

  function wireTextarea(el) {
    var ta      = el.querySelector('textarea');
    var counter = el.querySelector('[data-counter]');
    if (!ta) return;
    var prop  = ta.dataset.prop;
    var maxCh = ta.maxLength > 0 ? ta.maxLength : 0;
    var price = parseInt(el.dataset.price) || 0;

    ta.addEventListener('input', function () {
      var val = this.value;
      state[prop] = val;
      setHidden(prop, val);
      if (price) {
        var optId = el.dataset.optId;
        if (!surchargeItems[optId]) surchargeItems[optId] = { price: price, name: prop, active: false, variantId: el.dataset.surchargeVariantId || null };
        surchargeItems[optId].active = val.length > 0;
        stateChanged();
      }
      if (el.dataset.required && val.trim()) el.classList.remove('wgh-opt--error');
      if (counter && maxCh) {
        var len = val.length;
        counter.textContent = len + '/' + maxCh;
        counter.className = 'wgh-opt-textarea-counter' +
          (len >= maxCh ? ' is-over' : len >= maxCh * 0.85 ? ' is-near' : '');
      }
    });
  }

  function wireSwitch(el) {
    var sw    = el.querySelector('.wgh-opt-switch');
    if (!sw) return;
    var prop         = sw.dataset.prop;
    var checkedVal   = sw.dataset.checkedVal;
    var uncheckedVal = sw.dataset.uncheckedVal;
    var price        = parseInt(el.dataset.price) || 0;

    function toggle() {
      var isOn = sw.classList.toggle('is-on');
      sw.setAttribute('aria-checked', String(isOn));
      var val = isOn ? checkedVal : uncheckedVal;
      state[prop] = val;
      setHidden(prop, val);
      if (el.dataset.required && isOn) el.classList.remove('wgh-opt--error');
      if (price) {
        if (!surchargeItems[el.dataset.optId]) surchargeItems[el.dataset.optId] = { price: price, name: prop, active: false, variantId: el.dataset.surchargeVariantId || null };
        surchargeItems[el.dataset.optId].active = isOn;
        stateChanged();
      }
    }

    // Init with default value
    var initOn = sw.classList.contains('is-on');
    setHidden(prop, initOn ? checkedVal : uncheckedVal);
    state[prop] = initOn ? checkedVal : uncheckedVal;
    if (price) {
      surchargeItems[el.dataset.optId] = { price: price, name: prop, active: initOn, variantId: el.dataset.surchargeVariantId || null };
    }

    sw.addEventListener('click', toggle);
    sw.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); }
    });
  }

  function wireSelect(el) {
    var style = el.dataset.style || 'dropdown';
    var price = parseInt(el.dataset.price) || 0;

    if (style === 'colors') {
      var wrap = el.querySelector('.wgh-opt-colors');
      if (!wrap) return;
      var prop = wrap.dataset.prop;
      var btns = wrap.querySelectorAll('.wgh-opt-color');

      function pickColor(btn) {
        btns.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var val = btn.dataset.value;
        state[prop] = val;
        setHidden(prop, val);
        evalConditions();
      }

      // Init first
      if (btns.length) pickColor(btns[0]);

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () { pickColor(this); });
      });

    } else if (style === 'buttons') {
      var wrap = el.querySelector('.wgh-opt-btns');
      if (!wrap) return;
      var prop = wrap.dataset.prop;
      var btns = wrap.querySelectorAll('.wgh-opt-btn');

      function pickBtn(btn) {
        btns.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var val = btn.dataset.value;
        state[prop] = val;
        setHidden(prop, val);
        evalConditions();
      }

      if (btns.length) pickBtn(btns[0]);

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () { pickBtn(this); });
      });

    } else if (style === 'tiles') {
      var wrap  = el.querySelector('.wgh-opt-tiles');
      if (!wrap) return;
      var prop  = wrap.dataset.prop;
      var optId = el.dataset.optId;
      var btns  = wrap.querySelectorAll('.wgh-opt-tile');

      function pickTile(btn) {
        btns.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var tPrice = parseInt(btn.dataset.price) || 0;
        var tSvid  = btn.dataset.surchargeVariantId || null;
        state[prop] = btn.dataset.value;
        setHidden(prop, btn.dataset.value);
        surchargeItems[optId] = { price: tPrice, name: prop, active: tPrice > 0, variantId: tSvid };
        stateChanged();
      }

      var initial = wrap.querySelector('.wgh-opt-tile.is-selected') || btns[0];
      if (initial) {
        var initPrice = parseInt(initial.dataset.price) || 0;
        state[prop] = initial.dataset.value;
        setHidden(prop, initial.dataset.value);
        if (initPrice) {
          surchargeItems[optId] = { price: initPrice, name: prop, active: true, variantId: initial.dataset.surchargeVariantId || null };
        }
      }

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () { pickTile(this); });
      });

    } else {
      var sel   = el.querySelector('select');
      if (!sel) return;
      var prop  = sel.dataset.prop;
      var optId = el.dataset.optId;

      function updateSel() {
        var selOpt    = sel.options[sel.selectedIndex];
        var vPrice    = selOpt ? (parseInt(selOpt.dataset.price) || 0) : 0;
        var vSvid     = selOpt ? (selOpt.dataset.svid || el.dataset.surchargeVariantId || null) : (el.dataset.surchargeVariantId || null);
        var itemPrice = vPrice > 0 ? vPrice : price;

        state[prop] = sel.value;
        setHidden(prop, sel.value);

        var badge = el.querySelector('.wgh-opt__label-badge');
        if (badge) {
          if (itemPrice > 0) {
            badge.textContent = '+ ' + fmt(itemPrice);
            badge.style.display = '';
          } else {
            badge.style.display = 'none';
          }
        }

        if (itemPrice > 0 || surchargeItems[optId]) {
          surchargeItems[optId] = { price: itemPrice, name: prop, active: itemPrice > 0, variantId: vSvid };
          stateChanged();
        } else {
          evalConditions();
        }
      }
      updateSel();
      sel.addEventListener('change', updateSel);
    }
  }

  function wireAddon(el) {
    var card = el.querySelector('.wgh-opt-addon');
    if (!card) return;
    var addonId   = card.dataset.addonId;
    var variantId = card.dataset.variantId;
    var price     = parseInt(card.dataset.price) || 0;

    addonItems[addonId] = { variant_id: variantId, price: price, selected: false };

    function toggle() {
      var isOn = card.classList.toggle('is-selected');
      card.setAttribute('aria-checked', String(isOn));
      addonItems[addonId].selected = isOn;
      if (isOn && el.dataset.required) el.classList.remove('wgh-opt--error');
      stateChanged();
    }

    card.addEventListener('click', toggle);
    card.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); }
    });
  }

  function wireUpsell(el) {
    var card      = el.querySelector('.wgh-opt-upsell');
    if (!card) return;
    var upsellId  = card.dataset.upsellId;
    var variantId = card.dataset.variantId;
    var price     = parseInt(card.dataset.price) || 0;
    var qtyVal    = card.querySelector('.wgh-opt-upsell__qty-val');
    var minusBtn  = card.querySelector('[data-upsell-minus]');
    var plusBtn   = card.querySelector('[data-upsell-plus]');
    var titleEl    = card.querySelector('.wgh-opt-upsell__title');
    var variantEl  = card.querySelector('.wgh-opt-upsell__variant');
    var optLabelEl = el.querySelector('.wgh-opt__label');

    upsellItems[upsellId] = {
      variant_id:  variantId,
      price:       price,
      origPrice:   parseInt(card.dataset.origPrice) || price,
      quantity:    1,
      selected:    false,
      title:       titleEl    ? titleEl.textContent.trim()    : '',
      variantName: variantEl  ? variantEl.textContent.trim()  : '',
      optLabel:    optLabelEl ? optLabelEl.textContent.trim() : ''
    };

    function setSelected(isOn) {
      upsellItems[upsellId].selected = isOn;
      card.classList.toggle('is-selected', isOn);
      card.setAttribute('aria-checked', String(isOn));
      var qty = upsellItems[upsellId].quantity || 1;
      if (minusBtn) minusBtn.disabled = !isOn || qty <= 1;
      if (plusBtn)  plusBtn.disabled  = !isOn;
      stateChanged();
    }

    function setQty(qty) {
      var q = Math.max(1, qty);
      upsellItems[upsellId].quantity = q;
      if (qtyVal) qtyVal.textContent = q;
      if (minusBtn) minusBtn.disabled = q <= 1;
      if (upsellItems[upsellId].selected) stateChanged();
    }

    // Whole card toggles; qty buttons and view-link stop propagation
    card.addEventListener('click', function (e) {
      if (e.target.closest('[data-upsell-minus],[data-upsell-plus],[data-upsell-view]')) return;
      setSelected(!upsellItems[upsellId].selected);
    });
    card.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        setSelected(!upsellItems[upsellId].selected);
      }
    });

    if (minusBtn) {
      minusBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        setQty((upsellItems[upsellId].quantity || 1) - 1);
      });
    }
    if (plusBtn) {
      plusBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        setQty((upsellItems[upsellId].quantity || 1) + 1);
      });
    }

    // Fetch Shopify data when price/title/image not in config
    if (card.dataset.fetchVariant === '1' && variantId) {
      var productHandle = card.dataset.productHandle || '';
      var discPct    = parseFloat(card.dataset.discountPct)    || 0;
      var discAmount = parseFloat(card.dataset.discountAmount) || 0;

      function applyPricing(shopPrice, shopCompare) {
        var origPrice, discPrice;
        if (discPct) {
          origPrice = shopPrice;
          discPrice = Math.round(shopPrice * (1 - discPct / 100));
        } else if (discAmount) {
          origPrice = shopPrice;
          discPrice = shopPrice - Math.round(discAmount * 100);
        } else if (shopCompare && shopCompare > shopPrice) {
          origPrice = shopCompare;
          discPrice = shopPrice;
        } else {
          origPrice = shopPrice;
          discPrice = shopPrice;
        }
        upsellItems[upsellId].price    = discPrice;
        upsellItems[upsellId].origPrice = origPrice;
        card.dataset.price    = discPrice;
        card.dataset.origPrice = origPrice;
        recalcTotal();

        var pricingEl = card.querySelector('.wgh-opt-upsell__pricing');
        if (pricingEl) {
          var origHtml  = (origPrice !== discPrice)
            ? '<span class="wgh-opt-upsell__orig-price">' + fmt(origPrice) + '</span>' : '';
          var badgeHtml = '';
          if (origPrice !== discPrice) {
            if (discPct) {
              badgeHtml = '<span class="wgh-opt-upsell__badge">-' + Math.round(discPct) + '%</span>';
            } else if (discAmount) {
              badgeHtml = '<span class="wgh-opt-upsell__badge">-' + fmt(Math.round(discAmount * 100)) + '</span>';
            } else {
              var savePct = Math.round((1 - discPrice / origPrice) * 100);
              if (savePct > 0) badgeHtml = '<span class="wgh-opt-upsell__badge">-' + savePct + '%</span>';
            }
          }
          pricingEl.innerHTML = origHtml + '<span class="wgh-opt-upsell__price">' + fmt(discPrice) + '</span>' + badgeHtml;
        }
      }

      function applyTitle(title) {
        if (!title || card.dataset.fetchTitle !== '1') return;
        var titleEl = card.querySelector('.wgh-opt-upsell__title');
        if (titleEl) titleEl.textContent = title;
        if (upsellItems[upsellId]) upsellItems[upsellId].title = title;
      }

      function applyVariant(name) {
        if (!name || card.dataset.fetchVariantName !== '1') return;
        var el = card.querySelector('.wgh-opt-upsell__variant');
        if (el) el.textContent = name;
        if (upsellItems[upsellId]) upsellItems[upsellId].variantName = name;
      }

      function applyImage(src, alt) {
        if (!src || card.dataset.fetchImage !== '1') return;
        var existingImg = card.querySelector('.wgh-opt-upsell__img');
        if (existingImg) {
          existingImg.src = src;
        } else {
          var img = document.createElement('img');
          img.className = 'wgh-opt-upsell__img';
          img.src = src;
          img.alt = alt || '';
          img.loading = 'lazy';
          card.insertBefore(img, card.firstChild);
        }
      }

      if (productHandle) {
        // Product fetch: gives product title, main image, and variant prices in one request
        fetch('/products/' + productHandle + '.js')
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.json();
          })
          .then(function (product) {
            var variant = null;
            var variants = product.variants || [];
            for (var i = 0; i < variants.length; i++) {
              if (String(variants[i].id) === String(variantId)) { variant = variants[i]; break; }
            }
            if (!variant && variants.length) variant = variants[0];

            applyPricing(variant ? variant.price || 0 : 0, variant ? variant.compare_at_price || 0 : 0);
            applyTitle(product.title);
            applyVariant(variant ? variant.title : '');
            var imgSrc = (variant && variant.featured_image && variant.featured_image.src) ||
                         (product.featured_image) ||
                         (product.images && product.images[0] && product.images[0].src) || '';
            applyImage(imgSrc, product.title);
          })
          .catch(function (err) {
            console.warn('[WGH options] product fetch fout:', err);
            fetchVariant();
          });
      } else {
        fetchVariant();
      }

      function fetchVariant() {
        fetch('/variants/' + variantId + '.js')
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.json();
          })
          .then(function (v) {
            applyPricing(v.price || 0, v.compare_at_price || 0);
            // product_title is included in some Shopify responses
            applyTitle(v.product_title || '');
            applyVariant(v.title || '');
            var imgSrc = v.featured_image && v.featured_image.src ? v.featured_image.src : '';
            applyImage(imgSrc, v.product_title || v.title || '');
          })
          .catch(function (err) {
            console.warn('[WGH options] variant fetch fout:', err);
            var pricingEl = card.querySelector('.wgh-opt-upsell__pricing');
            if (pricingEl) pricingEl.innerHTML = '<span class="wgh-opt-upsell__price">—</span>';
          });
      }
    }
  }

  function wireImageSwatch(el) {
    var wrap    = el.querySelector('.wgh-opt-imgswatches');
    if (!wrap) return;
    var prop    = wrap.dataset.prop;
    var optId   = el.dataset.optId;
    var buttons = wrap.querySelectorAll('.wgh-opt-imgswatch');

    function pick(btn) {
      buttons.forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      var val   = btn.dataset.value;
      var price = parseInt(btn.dataset.price) || 0;
      var svid  = btn.dataset.surchargeVariantId || el.dataset.surchargeVariantId || null;
      state[prop] = val;
      setHidden(prop, val);
      surchargeItems[optId] = { price: price, name: prop, active: price > 0, variantId: svid };
      stateChanged();
      if (el.dataset.required) el.classList.remove('wgh-opt--error');
    }

    var initial = wrap.querySelector('.wgh-opt-imgswatch.is-selected');
    if (initial) {
      var initPrice = parseInt(initial.dataset.price) || 0;
      state[prop] = initial.dataset.value;
      setHidden(prop, initial.dataset.value);
      if (initPrice) {
        surchargeItems[optId] = { price: initPrice, name: prop, active: true, variantId: initial.dataset.surchargeVariantId || el.dataset.surchargeVariantId || null };
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () { pick(this); });

      var popupImg = btn.querySelector('.wgh-opt-imgswatch__popup img');
      if (popupImg && popupImg.src) {
        var imgSrc = popupImg.src;
        btn.addEventListener('mouseenter', function () {
          if (!_swatchPopupEl) {
            _swatchPopupEl = document.createElement('div');
            _swatchPopupEl.style.cssText = 'position:fixed;width:140px;height:140px;border-radius:10px;overflow:hidden;box-shadow:0 6px 20px rgba(0,0,0,.25);pointer-events:none;z-index:9999;background:#f0ece6;transition:opacity .12s';
            var pi = document.createElement('img');
            pi.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block';
            _swatchPopupEl.appendChild(pi);
            document.body.appendChild(_swatchPopupEl);
          }
          _swatchPopupEl.querySelector('img').src = imgSrc;
          var r   = btn.getBoundingClientRect();
          var pw  = 140, ph = 140, gap = 10;
          var top = r.top - ph - gap;
          if (top < 8) top = r.bottom + gap;
          var left = r.left + r.width / 2 - pw / 2;
          left = Math.max(8, Math.min(left, window.innerWidth - pw - 8));
          _swatchPopupEl.style.top     = top  + 'px';
          _swatchPopupEl.style.left    = left + 'px';
          _swatchPopupEl.style.opacity = '1';
          _swatchPopupEl.style.display = 'block';
        });
        btn.addEventListener('mouseleave', function () {
          if (_swatchPopupEl) { _swatchPopupEl.style.opacity = '0'; _swatchPopupEl.style.display = 'none'; }
        });
      }
    });
  }

  function wireFont(el) {
    var wrap    = el.querySelector('.wgh-opt-fonts');
    if (!wrap) return;
    var prop    = wrap.dataset.prop;
    var buttons = wrap.querySelectorAll('.wgh-opt-font');

    buttons.forEach(function (btn) {
      loadFont(btn.dataset.fontFamily, btn.dataset.fontUrl);
    });

    function pick(btn) {
      buttons.forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      var val = btn.dataset.value;
      state[prop] = val;
      setHidden(prop, val);
      evalConditions();
      if (el.dataset.required) el.classList.remove('wgh-opt--error');
    }

    var initial = wrap.querySelector('.wgh-opt-font.is-selected') || buttons[0];
    if (initial) {
      state[prop] = initial.dataset.value;
      setHidden(prop, initial.dataset.value);
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () { pick(this); });
    });
  }

  /* ── Cart integration ────────────────────────────────────── */

  // Read price→variantId map from data-surcharge-map attribute (set by Liquid)
  function loadSurchargeVariants() {
    if (surchargeLoadPromise) return surchargeLoadPromise;
    surchargeLoadPromise = Promise.resolve().then(function () {
      if (Object.keys(surchargeVariantCache).length) return;
      var raw = (mount && mount.dataset.surchargeMap) || '';
      if (!raw) {
        console.warn('[WGH options] data-surcharge-map is leeg. Controleer of het product "wgh-meerkosten" bestaat in Shopify.');
        return;
      }
      raw.split(',').forEach(function (entry) {
        var parts = entry.split(':');
        if (parts.length === 2) surchargeVariantCache[parseInt(parts[0])] = parseInt(parts[1]);
      });
    });
    return surchargeLoadPromise;
  }

  function getCartToken() {
    var match = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
    if (match) return Promise.resolve(decodeURIComponent(match[1]));
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { return c.token || ('new-' + Date.now()); });
  }

  /* ── Base price + variant-option state ──────────────────── */
  function initBasePrice(form) {
    var jsonEl = document.getElementById('wgh-product-json');
    if (!jsonEl) return;
    var productData;
    try { productData = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    // Build option name list (e.g. ["Houttype", "Maat"])
    var optionNames = (productData.options || []).map(function (o) {
      return typeof o === 'object' && o.name ? o.name : String(o);
    });

    // Build variant lookup: id → { price, option1, option2, option3 }
    var variantMap = {};
    (productData.variants || []).forEach(function (v) {
      variantMap[v.id] = { price: v.price, option1: v.option1, option2: v.option2, option3: v.option3 };
    });

    var variantInput = form && form.querySelector('input[name="id"]');

    function updateVariant() {
      var vid = variantInput ? parseInt(variantInput.value) : 0;
      var v = variantMap[vid];
      basePrice = v ? v.price : 0;
      if (v) {
        // Expose options as "option1"/"option2"/"option3" AND by Shopify option name
        ['option1', 'option2', 'option3'].forEach(function (key, i) {
          if (v[key] != null) {
            state[key] = v[key];
            if (optionNames[i]) state[optionNames[i]] = v[key];
          }
        });
        evalConditions();
      }
      recalcTotal();
    }

    updateVariant();

    if (variantInput) {
      variantInput.addEventListener('change', updateVariant);
    }
  }

  function hideOptionsHeading() {
    var card = mount && mount.closest('.wgh-options-card');
    if (!card) return;
    if (!card.querySelector('.wgh-option-group')) {
      var heading = card.querySelector('.wgh-options-card__heading');
      if (heading) heading.style.display = 'none';
    }
  }

  /* ── Main init ───────────────────────────────────────────── */
  function init() {
    mount = document.getElementById('wgh-product-options');
    if (!mount) return;

    productId = mount.dataset.productId;
    apiBase = mount.dataset.apiBase || '';

    fetch(apiBase + '/api/public/mapbox-settings')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d && d.accessToken) _globalMapboxToken = d.accessToken; })
      .catch(function () {});
    var formId  = mount.dataset.formId;

    // Create hidden input container inside the Shopify product form
    var form = formId ? document.getElementById(formId) : document.querySelector('.wgh-product-form');
    if (form) {
      hiddenContainer = document.createElement('div');
      hiddenContainer.id = 'wgh-opts-hidden';
      hiddenContainer.style.display = 'none';
      form.appendChild(hiddenContainer);

      function _doWghAtc() {
        if (!validateRequired()) {
          var firstError = mount && mount.querySelector('.wgh-opt--error');
          if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        var toAdd = [];
        var needsMapLoad = false;
        var qtyInput = form.querySelector('input[name="quantity"]');
        var productQty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        Object.keys(surchargeItems).forEach(function (id) {
          var s = surchargeItems[id];
          if (!s.active || !s.price) return;
          if (s.variantId) {
            var pushItem = { variantId: s.variantId, name: s.name };
            if (s.quantity) pushItem.quantity = s.quantity * productQty;
            else if (productQty > 1) pushItem.quantity = productQty;
            if (s.textValue !== undefined) pushItem.textValue = s.textValue;
            if (s.pricePerChar) pushItem.pricePerChar = s.pricePerChar;
            if (s.numberValue !== undefined) pushItem.numberValue = s.numberValue;
            if (s.pricePerUnit) pushItem.pricePerUnit = s.pricePerUnit;
            toAdd.push(pushItem);
          } else needsMapLoad = true;
        });
        Object.keys(addonItems).forEach(function (id) {
          var a = addonItems[id];
          if (a.selected && a.variant_id) toAdd.push({ variantId: a.variant_id, name: null, quantity: productQty, price: null });
        });
        Object.keys(upsellItems).forEach(function (id) {
          var u = upsellItems[id];
          if (u.selected && u.variant_id) toAdd.push({
            variantId:   u.variant_id,
            name:        u.title       || null,
            quantity:    u.quantity    || 1,
            price:       u.price,
            origPrice:   u.origPrice   || u.price,
            optLabel:    u.optLabel    || null,
            variantName: u.variantName || null
          });
        });

        var optProps = {};
        hiddenContainer && hiddenContainer.querySelectorAll('input[type="hidden"]').forEach(function (inp) {
          var prop = inp.dataset.prop;
          if (prop && !prop.startsWith('_wgh_')) optProps[prop] = inp.value;
        });

        // Knop blokkeren tijdens async verwerking
        var _submitBtn = form.querySelector('[name="add"]')
          || (form.id ? document.querySelector('[name="add"][form="' + form.id + '"]') : null)
          || form.querySelector('[type="submit"]');
        if (_submitBtn) { _submitBtn.disabled = true; _submitBtn.dataset.wghSubmitting = '1'; }

        var work = needsMapLoad
          ? loadSurchargeVariants().then(function () {
              Object.keys(surchargeItems).forEach(function (id) {
                var s = surchargeItems[id];
                if (!s.active || !s.price || s.variantId) return;
                var vid = surchargeVariantCache[s.price];
                if (vid) toAdd.push({ variantId: vid, name: s.name, quantity: productQty });
                else console.warn('[WGH options] geen variant voor prijs', s.price);
              });
            })
          : Promise.resolve();

        work.then(function () {
          return getCartToken();
        }).then(function (cartToken) {
          var discountCode     = null;
          var validationFailed = false;

          var items = toAdd.map(function (item) {
            var p = { _wgh_parent_product: String(productId), _wgh_addon: '1' };
            if (item.name)                      p._wgh_for            = item.name;
            if (item.optLabel)                  p._wgh_opt_label      = item.optLabel;
            if (item.variantName)               p._wgh_variant        = item.variantName;
            if (item.price != null)             p._wgh_disc_price     = String(item.price);
            if (item.textValue !== undefined)   p._wgh_text_value     = item.textValue;
            if (item.pricePerChar)              p._wgh_price_per_char = String(item.pricePerChar);
            if (item.numberValue !== undefined) p._wgh_number_value   = String(item.numberValue);
            if (item.pricePerUnit)              p._wgh_price_per_unit = String(item.pricePerUnit);
            var entry = { variant_id: parseInt(item.variantId), quantity: item.quantity || 1, properties: p };
            if (item.price != null)     entry.price      = item.price;
            if (item.origPrice != null) entry.orig_price = item.origPrice;
            return entry;
          });

          var payload = {
            cart_token:     cartToken,
            items:          items,
            product_qty:    productQty,
            product_id:     productId,
            variant_id:     (form.querySelector('[name="id"]') || {}).value || null,
            variant_state:  state,
            opt_properties: optProps
          };

          fetch(apiBase + '/api/shopify/addToCartV2', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          })
          .then(function (res) {
            return res.json().then(function (d) {
              if (!res.ok) {
                validationFailed = true;
                var errMsg = typeof d.error === 'string' ? d.error : '';
                if (!errMsg || errMsg === 'cart_token is verplicht') errMsg = 'Er is iets mis gegaan, neem contact met ons op.';
                showWghError(errMsg);
                throw new Error((typeof d.error === 'string' ? d.error : '') || 'API fout ' + res.status);
              }
              return d;
            });
          })
          .then(function (data) {
            if (data && data.discount_code)  discountCode = data.discount_code;
            if (data && data.discount_error) console.warn('[WGH] discount fout:', data.discount_error);

            var serverItems = (data && Array.isArray(data.items) && data.items.length) ? data.items : [];
            if (!serverItems.length) {
              window.location.href = discountCode
                ? '/discount/' + discountCode + '?return_url=/cart'
                : '/cart';
              return;
            }

            // Bewaar items in sessionStorage als vangnet voor Safari private mode:
            // als de cart-cookie niet goed bewaard wordt na redirect is de
            // herstelcode in main-cart-footer.liquid beschikbaar om ze terug te zetten.
            try { sessionStorage.setItem('wgh_pending_addons', JSON.stringify(serverItems)); } catch (e) {}

            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: serverItems })
            }).then(function (r) {
              return r.json().then(function (result) {
                if (!r.ok) {
                  validationFailed = true;
                  showWghError(result.description || result.message || 'Er is iets mis gegaan, neem contact met ons op.');
                  throw new Error('Cart add fout');
                }
              });
            });
          })
          .then(function () {
            window.location.href = discountCode
              ? '/discount/' + discountCode + '?return_url=/cart'
              : '/cart';
          })
          .catch(function (err) {
            if (_submitBtn) { _submitBtn.disabled = false; delete _submitBtn.dataset.wghSubmitting; }
            if (validationFailed) return;
            console.warn('[WGH options] fout:', err);
            // Fallback als WGH API onbereikbaar is
            fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
              .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || 'fout'); }); })
              .then(function () { window.location.href = '/cart'; })
              .catch(function () { isSecondPass = true; if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
          });
        });
      }

      // Primaire interceptie: window click capture — vuurt vóór elke bubble-listener van Dawn
      window.addEventListener('click', function (e) {
        // Zoek de dichtstbijzijnde [name="add"] knop in de click-keten
        var btn = e.target;
        while (btn && btn !== document.documentElement) {
          if (btn.getAttribute && btn.getAttribute('name') === 'add') break;
          btn = btn.parentElement;
        }
        if (!btn || btn.getAttribute('name') !== 'add') return;

        // Alleen als deze knop bij ons formulier hoort
        var btnFormId = btn.getAttribute('form');
        var btnForm   = btnFormId ? document.getElementById(btnFormId) : (btn.closest ? btn.closest('form') : null);
        if (btnForm !== form) return;

        // Sla over als knop geblokkeerd is
        if (btn.disabled || btn.dataset.wghLoading || btn.dataset.wghSubmitting) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        _doWghAtc();
      }, true);

      // Backup: onderschep ook submit-events (Enter-toets, form.requestSubmit fallback)
      window.addEventListener('submit', function (e) {
        if (e.target !== form) return;
        if (isSecondPass) { isSecondPass = false; return; } // laat native submit door voor fallback
        e.preventDefault();
        e.stopImmediatePropagation();
        _doWghAtc();
      }, true);
    }

    watchVariantSelectors(form);
    initBasePrice(form);

    // Find and disable ATC button while options are loading to prevent race conditions
    _atcBtn = form
      ? (form.querySelector('[name="add"]')
          || (form.id ? document.querySelector('[name="add"][form="' + form.id + '"]') : null)
          || form.querySelector('[type="submit"]'))
      : null;
    if (_atcBtn && !_atcBtn.disabled) {
      _atcBtn.disabled = true;
      _atcBtn.dataset.wghLoading = '1';
    }

    // Fetch options from API
    var url = apiBase + '/api/public/product/options/' + productId;
    fetch(url)
      .then(function (res) {
        if (res.status === 404) { mount.innerHTML = ''; hideOptionsHeading(); return null; }
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data) { _releaseAtcBtn(); return; }
        var opts = data.productOptions || [];
        if (!opts.length) {
          mount.innerHTML = '';
          hideOptionsHeading();
          _releaseAtcBtn();
          return;
        }
        renderAll(opts);
        _releaseAtcBtn();
      })
      .catch(function (err) {
        console.warn('[WGH options] fetch error:', err);
        mount.innerHTML = '<div class="wgh-opts-error">Opties konden niet worden geladen.</div>';
        _releaseAtcBtn();
      });
  }

  function _releaseAtcBtn() {
    if (_atcBtn && _atcBtn.dataset.wghLoading) {
      _atcBtn.disabled = false;
      delete _atcBtn.dataset.wghLoading;
    }
  }

  function renderAll(opts) {
    injectErrorStyles();
    var html = '';
    opts.forEach(function (opt) {
      switch (opt.field_type) {
        case 'upload':   html += renderUpload(opt);   break;
        case 'text':     html += renderText(opt);     break;
        case 'number':   html += renderNumber(opt);   break;
        case 'textarea': html += renderTextarea(opt); break;
        case 'switch':   html += renderSwitch(opt);   break;
        case 'select':   html += renderSelect(opt);   break;
        case 'addon':         html += renderAddon(opt);        break;
        case 'image_swatch':  html += renderImageSwatch(opt);  break;
        case 'font':          html += renderFont(opt);         break;
        case 'upsell':        html += renderUpsell(opt);       break;
        case 'configurator':  html += renderConfigurator(opt); break;
        case 'info':          html += renderInfo(opt);         break;
        default: break;
      }
    });

    // Append price total badge
    html += '<div class="wgh-opts-total" hidden>' +
      '<span class="wgh-opts-total__label">Meerkosten opties</span><span class="wgh-opts-total__value"></span>' +
      '<hr class="wgh-opts-total__sep">' +
      '<span class="wgh-opts-grand__label">Totaalprijs</span><span class="wgh-opts-grand__value"></span>' +
      '</div>';

    mount.innerHTML = html;
    totalEl = mount.querySelector('.wgh-opts-total');

    // Conditional fields always start hidden; evalConditions reveals matching ones
    mount.querySelectorAll('.wgh-opt[data-show-if]').forEach(function (el) {
      el.classList.add('wgh-opt--hidden');
    });

    // Wire events — block evalConditions until all initial state is set
    _initializing = true;
    mount.querySelectorAll('.wgh-opt').forEach(function (el) {
      var type = el.dataset.type;
      if (type === 'upload')   wireUpload(el);
      else if (type === 'text')     wireText(el);
      else if (type === 'number')   wireNumber(el);
      else if (type === 'textarea') wireTextarea(el);
      else if (type === 'switch')   wireSwitch(el);
      else if (type === 'select')   wireSelect(el);
      else if (type === 'addon')         wireAddon(el);
      else if (type === 'image_swatch')  wireImageSwatch(el);
      else if (type === 'font')          wireFont(el);
      else if (type === 'upsell')        wireUpsell(el);
      else if (type === 'configurator')  wireConfigurator(el);
    });
    _initializing = false;

    recalcTotal();
    evalConditions();

  }

  /* ── Boot ────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();